import React from 'react';
import { Grid, Button } from '@mui/material';

const MobileButtons = ({
  isLast,
  index,
  maxSections,
  addFlightSection,
  removeFlightSection,
}) => {
  return (
    <Grid
      container
      item
      xs={12}
      sx={{
        display: { xs: 'flex', md: 'none' },
        justifyContent: 'space-between',
        mt: 1,
      }}
    >
      {isLast && (
        <Button
          onClick={() => removeFlightSection(index)}
          sx={{
            color: '#FF2020',
            fontSize: '12px',
            alignSelf: 'start',
            fontWeight: 600,
          }}
        >
          Eliminar tramo
        </Button>
      )}

      {isLast && index < maxSections && (
        <Button
          onClick={addFlightSection}
          sx={{
            fontSize: '12px',
            alignSelf: 'end',
            fontWeight: 600,
            color: 'rgb(87, 37, 255)',
          }}
        >
          Agregar tramo
        </Button>
      )}
    </Grid>
  );
};

export default MobileButtons;
